import styled from "@emotion/styled";
import { Button, Grid } from "@mui/material";
import { css } from "@emotion/react";

export const CustomFlex = styled.div((props) => ({
  display: "flex",
  justifyContent: props.content || "none",
  flexDirection: props.direction || "row",
  alignItems: props.align || "center",
}));

export const CenteredFlex = styled.div((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: props.direction || "row",
}));

export const CenteredGrid = styled.div((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: props.direction || "row",
}));

const dynamicStyle = (props) =>
  css`
    display: "flex";
    justify-content: ${props.content || "center"};
    flex-direction: ${props.direction || "row"};
    align-items: ${props.align || "center"};
  `;
export const CustomGrid = styled(Grid)`
  ${dynamicStyle};
`;

export const ColoredButton = styled(Button)((props) => ({
  color: props.color,
  "&:hover": {
    animationTimingFunction: "ease-out",
    animationDuration: "200ms",
  },
}));

export const CustomButton = styled(Button)`
  color: ${(props) => props.textColor};
  text-transform: none;
`;

export const Paragraph = styled.p`
font-family: "Inter";
font-size: 2.5rem;
font-weight: 300;
margin: 2rem 0;
`;